document.addEventListener('DOMContentLoaded', () => {
    const lastSeenProduct = document.querySelector('[data-last-seen-product]')?.getAttribute('data-last-seen-product');
    if (!lastSeenProduct) {
        return;
    }

    window.localStorage.setItem('last-seen-product', lastSeenProduct);

    const item = window.pageDataLayer?.ecommerce?.items?.[0];
    if (item?.item_id) {
        window.localStorage.setItem('last-seen-product-data', JSON.stringify({ identifier: lastSeenProduct, item }));
    } else {
        window.localStorage.removeItem('last-seen-product-data');
    }
});
